import * as yup from 'yup';
import { locationDisplayInformationSchema } from '../location/location-form.schema';

export const createRelatedLocationFormSchema = yup
  .object()
  .shape({
    relatedLocationName: yup.string().required().max(50),
    isCatering: yup.boolean().default(false),
  })
  .concat(locationDisplayInformationSchema);
